import Enumerable from "linq";

export class InitialFilterParameter {
  constructor(text: string = "") {
    this.keyword = text;
  }

  private _keyword: string;
  private regExps: RegExp[] = [];

  public get isEmpty(): boolean {
    return (this.regExps.length === 0);
  }

  public get keyword(): string {
    return this._keyword;
  }

  public set keyword(value: string) {
    this._keyword = value;
    const characters = (!!value) ? value.split("") : [];
    const regExps: RegExp[] = [];
    for (const character of characters) {
      const regExp = Enumerable.from(InitialFilterParameter.regexTexts)
        .firstOrDefault((regex) => (character.match(regex) != null));
      if (!!regExp) {
        regExps.push(regExp);
      }
    }
    this.regExps = regExps;
  }

  filter(source: string): boolean {
    if (this.regExps.length === 0) { return true; }
    if (!source) { return false; }
    for (const regExp of this.regExps) {
      if (regExp.test(source)) { return true; }
    }
    return false;
  }

  clone(): InitialFilterParameter {
    return new InitialFilterParameter(this.keyword);
  }

  private static readonly regexTexts: RegExp[] = [
    /^[あアｱ]/i,
    /^[いイｲ]/i,
    /^[うウｳ]/i,
    /^[えエｴ]/i,
    /^[おオｵ]/i,
    /^[かカｶがガ]/i,
    /^[きキｷぎギ]/i,
    /^[くクｸぐグ]/i,
    /^[けケｹげゲ]/i,
    /^[こコｺごゴ]/i,
    /^[さサｻざザ]/i,
    /^[しシｼじジ]/i,
    /^[すスｽずズ]/i,
    /^[せセｾぜゼ]/i,
    /^[そソｿぞゾ]/i,
    /^[たタﾀだダ]/i,
    /^[ちチﾁぢヂ]/i,
    /^[つツﾂづヅ]/i,
    /^[てテﾃでデ]/i,
    /^[とトﾄどド]/i,
    /^[なナﾅ]/i,
    /^[にニﾆ]/i,
    /^[ぬヌﾇ]/i,
    /^[ねネﾈ]/i,
    /^[のノﾉ]/i,
    /^[はハﾊばバぱパ]/i,
    /^[ひヒﾋびビぴピ]/i,
    /^[ふフﾌぶブぷプ]/i,
    /^[へヘﾍべベぺペ]/i,
    /^[ほホﾎぼボぽポ]/i,
    /^[まマﾏ]/i,
    /^[みミﾐ]/i,
    /^[むムﾑ]/i,
    /^[めメﾒ]/i,
    /^[もモﾓ]/i,
    /^[やヤﾔ]/i,
    /^[ゆユﾕ]/i,
    /^[よヨﾖ]/i,
    /^[らラﾗ]/i,
    /^[りリﾘ]/i,
    /^[るルﾙ]/i,
    /^[れレﾚ]/i,
    /^[ろロﾛ]/i,
    /^[わワﾜ]/i,
    /^[をヲｦ]/i,
    /^[んンﾝ]/i,
  ];
}
